<div class="row">
    <div class="col-1">

        <img src="{{itemDetails.iconImageUrl}}" [style.height]="itemDetails.iconImageStyle.height" [style.width]="itemDetails.iconImageStyle.width"  >

    </div>
    <div class="col-11">
        <div class="font_18 font_weight margintop_8 marginbottom_10">
            {{itemDetails.label | translate }}
        </div>
        <div *ngIf="itemData?.length === 0" class="font_15 primarySubTextColor marginbottom_10">
            {{itemDetails.notFoundMsg  | translate }}
        </div>
        <div *ngIf="!isArray(itemData);  else listBlock">
            <div class="row marginbottom_10">

                <div [ngClass]="getOverviewColsClass(thead.cols)" *ngFor="let thead of itemDetails.TableHeaders">
                  <div *ngIf="itemData  && !thead?.isconvertUom " >  {{itemData[thead.primaryText.key] }}</div>
                    <div *ngIf="itemData && thead?.isconvertUom" >  {{itemData[thead.primaryText.key]  | convertUom : itemData[thead.primaryText.unit]}} {{itemData[thead.primaryText.unit]}}</div>
                      <div *ngIf="thead.secondaryText" class="font_14 shipmentDetailsColor">
                        <ng-container *ngIf="thead.secondaryText.length > 0;else notAnArray">
                            <span *ngFor="let theadSecondary of thead.secondaryText let k=index">
                                {{theadSecondary.labelBefore}}
                                <ng-container *ngIf="thead.isconvertUom; else displayRawValue">
                                    {{itemData[theadSecondary.key] | convertUom :itemData[theadSecondary.key]}}
                                </ng-container>
                                <ng-template #displayRawValue>
                                    {{itemData ? itemData[theadSecondary.key] : ''}}
                                </ng-template>
                                 {{theadSecondary.labelAfter}}
                                <span *ngIf="(k+1)<thead.secondaryText.length">,</span>
                            </span>
                        </ng-container>
                        <ng-template #notAnArray>
                            <span *ngIf="!thead?.isconvertUom">
                               {{thead.secondaryText.labelBefore}}{{itemData ? itemData[thead.secondaryText.key]  : ''}} {{thead.secondaryText.labelAfter}}
                            </span>
                            <span *ngIf="thead?.isconvertUom">
                                  {{itemData[thead.secondaryText.key]  | convertUom :itemData[thead.secondaryText.key] }}
                              </span>
                        </ng-template>
                    </div>

                </div>

            </div>
        </div>
        <ng-template #listBlock>
        <div *ngIf="itemData.length > 0" class="font_15 primarySubTextColor">
            <!-- <div *ngFor="let thead of itemDetails.TableHeaders"> -->
                <div *ngFor="let item of itemData  let i=index;">
                    <div class="row marginbottom_10">
                        <div *ngIf="itemDetails.lineNumber" class="col-md-1">
                            {{i+1+'.'}}
                        </div>
                        <div  [ngClass]="getOverviewColsClass(thead.cols)" *ngFor="let thead of itemDetails.TableHeaders">
                            <div>{{item[thead.primaryText.key]}}{{item[thead.primaryText.unit]}}</div>

                            <div class="font_14 shipmentDetailsColor">
                                <ng-container *ngIf="thead.secondaryText.length > 0;else notAnArray">
                                <span *ngFor="let theadSecondary of thead.secondaryText let k=index">
                                    {{theadSecondary.labelBefore}}{{item[theadSecondary.key]}} {{theadSecondary.labelAfter}}
                                    <span *ngIf="(k+1)<thead.secondaryText.length">,</span>
                                </span>
                                </ng-container>
                                <ng-template #notAnArray>
                                    <span>
                                        {{thead.secondaryText.labelBefore}}{{item ? item[thead.secondaryText.key] : ''}} {{thead.secondaryText.labelAfter}}
                                    </span>
                                </ng-template>   
                            </div>

                        </div>
                        <!-- <div class="shipmentDetailsColor font_14">
                        {{item.secondary}}
                    </div> -->
                    </div>
                </div>
            <!-- </div> -->
        </div>
        </ng-template>
    </div>
    <div class="overviewSeperator" [ngClass]="{'hide': itemList?.length-1 === index}"></div>
</div>
